import { render, staticRenderFns } from "./CreateSubconInvoice.vue?vue&type=template&id=2260362a"
import script from "./CreateSubconInvoice.vue?vue&type=script&lang=js"
export * from "./CreateSubconInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports